import { BoxProps, Text, TextProps } from '@chakra-ui/react'
import { ObjectContentNode } from '@helo/cms'

import { ConditionalLink } from '../../components/Link/Link'
import { InlineSkeleton } from '../../components/SkeletonLoader'
import { ConditionalTooltip } from '../../components/Tooltip/Tooltip'
import { valueTransformer } from '../../utils/valueFormatter'
import { pillStyles } from '../utils'
import { PlaceDataType } from './place.types'

export const placeToString = (value: PlaceDataType['value']) => {
  if (!value) return '-'

  return `${value.value}`
}

export type PlaceRendererProps = {
  contentNode: ObjectContentNode
  isLoading?: boolean
} & BoxProps

// const defaultOptions: PlaceDataType['options'] = {}

export const PlaceRenderer = ({
  contentNode,
  isLoading,
  ...props
}: PlaceRendererProps) => {
  const state = contentNode.state ?? {}
  // const mergedOptions = merge({}, defaultOptions, options)
  const { size, linkUrlStorage, linkUrl, _tooltip, textCase, styles } = state

  const isReferenceObject =
    state.asValue &&
    typeof state.asValue === 'object' &&
    'kind' in state.asValue
  let value = isReferenceObject ? null : state.asValue

  if (value && typeof value === 'object' && '__typename' in value) {
    value = value.displayValue ?? value.alignedLabel ?? value.displayLabel
  }

  // const tooltipLabelText = context?.field?.label ?? 'Location Name'
  const capitalizeStyles: TextProps =
    textCase === 'all'
      ? { textTransform: 'uppercase' }
      : textCase === 'word'
        ? { textTransform: 'capitalize' }
        : {}

  // Extract styles object if it exists and is an object
  const customStyles = styles && typeof styles === 'object' ? styles : {}

  // Get notation for tooltip value
  // GraphQL Place field `displayLabel` (data path), not CMS state.
  const placeDataLabel = (contentNode.data as any)?.displayLabel

  // Hack for milestones:
  // Use provided tooltip options if specified, use fallback for milestone place objects
  // or don't use if no tooltip options are provided
  const { useFallback, ...tooltipOptions } = _tooltip ?? {}
  const finalTooltipOptions = useFallback
    ? {
        label: 'Service Provider Location Name:',
        asValue: placeDataLabel,
        ...tooltipOptions,
      }
    : _tooltip

  return (
    <ConditionalTooltip
      tooltipOptions={finalTooltipOptions}
      isDisabled={Boolean(!contentNode.data) || isLoading || !value}
    >
      <ConditionalLink
        isDisabled={isLoading}
        to={linkUrl}
        search={linkUrlStorage}
      >
        <Text
          size={size}
          {...(linkUrl && pillStyles)}
          {...capitalizeStyles}
          {...props}
          {...customStyles}
        >
          <InlineSkeleton isLoading={isLoading}>
            {valueTransformer(value)}
          </InlineSkeleton>
        </Text>
      </ConditionalLink>
    </ConditionalTooltip>
  )
}
